<!-- @format -->
@let location = locationInfo();

<ng-template #locationContent let-isDesktop="isDesktop">
	@if (location) {
		<div
			class="store-text"
			[class]="isDesktop || !moveFulfillmentToFilters()
				? 'hmf-body-bold-s hmf-text-transform-uppercase'
				: 'hmf-body-s'">
			{{ location.label }}
		</div>
		<button
			hmf-action-text
			[class]="isDesktop
				? 'hmf-pt-0 hmf-px-0 hmf-mb-0 hmf-overflow-hidden store-info-desktop hmf-text-align-left'
				: 'hmf-px-0 store-name hmf-subheader-bold-m hmf-overflow-hidden hmf-text-align-left hmf-display-inline-block ' +
					(mobileSelectionPosition() === 'left' ? 'store-name-left-position' : 'hmf-pt-xxxs')"
			[variant]="'secondary'"
			[attr.aria-label]="location.ariaLabel + ', ' + location.value"
			(click)="changeLocationAndStoreName.emit(location.changeHint ?? 'ship')">
			{{ location.value | titlecase }}
		</button>
	}
</ng-template>

<ng-template #mobileFulfillmentSelection>
	<div class="store-info hmf-align-content-center"
		[class.hmf-display-none]="!location"
		[class.hmf-ml-xxl]="mobileSelectionPosition() === 'top'">
		<div
			class="hmf-display-flex hmf-flex-column hmf-justify-content-center hmf-py-0"
			[class]="mobileSelectionPosition() === 'top' ?
				'hmf-mt-xs hmf-mb-xxxs hmf-pl-s store-info-mobile hmf-my-xxxs' : ''">
			<ng-container
				[ngTemplateOutlet]="locationContent"
				[ngTemplateOutletContext]="{ isDesktop: false }" />
		</div>
	</div>
</ng-template>

@if (showMobileSelection() && mobileSelectionPosition() === 'top') {
	<ng-container *ngTemplateOutlet="mobileFulfillmentSelection"></ng-container>
}
<div
	class="shipping-options-container hide-scroll-bar hmf-mb-m-0 hmf-body-bold-m hmf-display-flex hmf-align-items-flex-end fill-base hmf-py-lg-xxs"
	[class]="mobileSelectionPosition() === 'left' ? 'hmf-py-xs hmf-pl-xxs': ''">
		@if(!isMobile()){
			@if(!exposedFiltersEnabled()) {
				<div
					class="hmf-display-none hmf-display-lg-flex"
					[class.hmf-align-self-lg-center]="!sameDayDeliveryEnabled()">
					<span
						class="hmf-subheader-bold-m hmf-my-m-xs hmf-mt-l-xs shipping-option-label hmf-mr-s">
						SHIPPING
					</span>
				</div>
			}
			@if (location) {
				<div
					class="pickup-shipping-container hmf-display-none hmf-justify-content-between hmf-align-items-center hmf-overflow-x-hidden"
					[class.hmf-flex-m-wrap]="!exposedFiltersEnabled()"
					[class.hmf-display-lg-flex]="!!location">
					<div
						class="store-info hmf-display-flex hmf-flex-column hmf-body-m hmf-mr-xxs"
						[class.hmf-ml-m-0]="location.key === 'SHIP' || location.key === 'ISA'"
						[class.hmf-ml-s]="location.key === 'SHIP' || location.key === 'ISA'">
						<ng-container
							[ngTemplateOutlet]="locationContent"
							[ngTemplateOutletContext]="{ isDesktop: true }" />
					</div>
				</div>
			}
		}
		<div class="options hmf-display-flex hmf-justify-content-between hmf-px-lg-0 hmf-pr-xxxs shipping-options hide-scroll-bar hmf-flex-nowrap hmf-gap-xxs"
			[class.hmf-align-items-m-flex-end]="(mobileSelectionPosition() !== 'left')"
			[class.hmf-align-items-m-center]="(mobileSelectionPosition() === 'left')"
			[class]="!!location || (isMobile() && mobileSelectionPosition() === 'left') ? 'hmf-pl-xxs' : 'hmf-pl-s hmf-ml-xxl hmf-ml-lg-0'">
			@if (showMobileSelection() && mobileSelectionPosition() === 'left') {
				<ng-container *ngTemplateOutlet="mobileFulfillmentSelection"></ng-container>
			}
				@for (option of shippingOptionsKeys(); track option) {
					<plp-components-shipping-option-button
						[id]="'option-button-' + option.toLowerCase()"
						[shippingOption]="shippingOptions[option]"
						[selected]="location?.key === option"
						[disabled]="disabled()"
						[isMobile]="isMobile()"
						[fulfillmentFacetsEnabled]="fulfillmentFacetsEnabled()"
						[hasFulfillmentData]="hasFulfillmentData()"
						[count]="fulfillmentFacets()[option]"
						(selectedOption)="setSelectedFilter(option)"
					></plp-components-shipping-option-button>
				}
		</div>
</div>
